import { render, staticRenderFns } from "./StockTrackingList.vue?vue&type=template&id=93f64572&scoped=true&"
import script from "./StockTrackingList.vue?vue&type=script&lang=js&"
export * from "./StockTrackingList.vue?vue&type=script&lang=js&"
import style0 from "./StockTrackingList.vue?vue&type=style&index=0&id=93f64572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f64572",
  null
  
)

export default component.exports